(function () {
  'use strict';

  function initSticky(root) {
    var card = root.querySelector('[data-ted-sp-card]');
    var bar = document.querySelector('[data-ted-sp-sticky]');
    var cta = document.querySelector('[data-ted-sp-sticky-cta]');
    if (!card || !bar) return;

    var mq = window.matchMedia('(max-width: 767px)');

    function syncChatPosition(on) {
      var lift = on && mq.matches ? bar.offsetHeight + 12 : 0;
      document.body.classList.toggle('ted-sp-sticky-on', Boolean(on && mq.matches));
      var selectors = [
        '#shopify-chat',
        'inbox-online-store-chat',
        '#dummy-chat-button',
        '#dummy-chat-button-iframe',
      ];
      selectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (lift) el.style.setProperty('bottom', lift + 'px', 'important');
          else el.style.removeProperty('bottom');
        });
      });
    }

    function setVisible(on) {
      if (!mq.matches) {
        bar.hidden = true;
        bar.classList.remove('is-on');
        document.documentElement.style.removeProperty('--ted-sp-sticky-offset');
        syncChatPosition(false);
        return;
      }
      bar.hidden = !on;
      bar.classList.toggle('is-on', on);
      document.documentElement.style.setProperty(
        '--ted-sp-sticky-offset',
        on ? bar.offsetHeight + 'px' : '0px'
      );
      syncChatPosition(on);
    }

    var io = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        setVisible(!entry.isIntersecting);
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );

    function sync() {
      if (!mq.matches) {
        setVisible(false);
        io.unobserve(card);
        return;
      }
      io.observe(card);
    }

    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', sync);
    else if (typeof mq.addListener === 'function') mq.addListener(sync);

    if (cta) {
      cta.addEventListener('click', function () {
        var order = root.querySelector('.ted-sp__order');
        if (order && !order.disabled) order.click();
      });
    }

    var chatObserver = new MutationObserver(function () {
      if (bar.classList.contains('is-on')) syncChatPosition(true);
    });
    chatObserver.observe(document.body, { childList: true, subtree: true });

    sync();
  }

  function boot() {
    var root = document.querySelector('[data-ted-sp]');
    if (root) initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
